/**
 * 直送退货管理
 */

import request from '@/utils/request'

/**
 * 获取账户列表
 * @param data
 */
export function userList(data) {
  return request({
    url: '/user/select',
    method: 'post',
    data
  })
}

/**
 * 获取创建人列表
 * @param data
 */
export function getCreateUserList(data) {
  return request({
    url: '/user/select/condition',
    method: 'post',
    data
  })
}

/**
 * 获取所有角色
 * @param data
 */
export function roleAllSelect(data) {
  return request({
    url: '/role/all/select',
    method: 'post',
    data
  })
}

/**
 * 获取公司枚举
 * @param data
 */
export function baseEnumsSelectCommon(data) {
  data = data || {}
  return request({
    url: '/base/enums/select/common',
    method: 'post',
    data
  })
}

/**
 * 用户账号新增
 * @param data
 */
export function userSave(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data
  })
}

/**
 * 用户账号详情查看
 * @param data
 */
export function userDetail(data) {
  return request({
    url: '/user/detail',
    method: 'post',
    data
  })
}

/**
 * 用户账号修改
 * @param data
 */
export function userUpdate(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data
  })
}

/**
 * 用户账号删除
 * @param data
 */
export function userDelete(data) {
  return request({
    url: '/user/delete',
    method: 'post',
    data
  })
}

/**
 * 用户账户批量密码重置
 * @param data
 */
export function userResetPassword(data) {
  return request({
    url: '/user/resetPassword',
    method: 'post',
    data
  })
}

/**
 * 用户账户批量启用
 * @param data
 */
export function userEnable(data) {
  return request({
    url: '/user/enable',
    method: 'post',
    data
  })
}

/**
 * 用户账户批量禁用
 * @param data
 */
export function userDisable(data) {
  return request({
    url: '/user/disable',
    method: 'post',
    data
  })
}

/**
 * 角色分页列表
 * @param data
 */
export function roleSelect(data) {
  return request({
    url: '/role/select',
    method: 'post',
    data
  })
}

/**
 * 角色新增
 * @param data
 */
export function roleSave(data) {
  return request({
    url: '/role/save',
    method: 'post',
    data
  })
}

/**
 * 角色修改
 * @param data
 */
export function roleUpdate(data) {
  return request({
    url: '/role/update',
    method: 'post',
    data
  })
}

/**
 * 角色详情
 * @param data
 */
export function roleDetail(data) {
  return request({
    url: '/role/detail',
    method: 'post',
    data
  })
}

/**
 * 角色删除
 * @param data
 */
export function roleDelete(data) {
  return request({
    url: '/role/delete',
    method: 'post',
    data
  })
}

/**
 * 角色资源详情
 * @param id
 */
export function roleMenuSelect(id) {
  return request({
    url: '/role/menu/select',
    method: 'post',
    data: { id: id }
  })
}

/**
 * 角色授权
 * @param data
 */
export function roleAuthorization(data) {
  return request({
    url: '/role/authorization',
    method: 'post',
    data
  })
}

/**
 * 查询当前登录人的所有权限
 */
export function roleSelectUserRole() {
  return request({
    url: '/role/selectUserRole',
    method: 'post',
    data: {}
  })
}

/**
 * 消息列表
 * @param data
 */
export function sysNoticeSelect(data) {
  return request({
    url: '/sysNotice/select',
    method: 'post',
    data
  })
}

/**
 * 消息详情
 * @param data
 */
export function sysNoticeSelectDetail(data) {
  return request({
    url: '/sysNotice/selectDetail',
    method: 'post',
    data
  })
}

/**
 * 消息发送
 * @param data
 */
export function sysNoticeSendNotice(data) {
  return request({
    url: '/sysNotice/sendNotice',
    method: 'post',
    data
  })
}

/**
 * 数据字典列表
 * @param data
 */
export function dictInitialize(data) {
  return request({
    url: '/dict/initialize',
    method: 'post',
    data
  })
}

/**
 * 数据字典的枚举列表
 * @param data
 */
export function dictEnumGetDictTypes(data) {
  return request({
    url: '/dict/enum/getDictTypes',
    method: 'post',
    data
  })
}

/**
 * 数据字典的枚举列表
 * @param data
 */
export function dictDetail(data) {
  return request({
    url: '/dict/detail',
    method: 'post',
    data
  })
}

/**
 * 数据字典修改
 * @param data
 */
export function dictUpdate(data) {
  return request({
    url: '/dict/update',
    method: 'post',
    data
  })
}

/**
 * 数据字典新增
 * @param data
 */
export function dictSave(data) {
  return request({
    url: '/dict/save',
    method: 'post',
    data
  })
}

/**
 * 数据字典删除
 * @param data
 */
export function dictDelete(data) {
  return request({
    url: '/dict/delete',
    method: 'post',
    data
  })
}

/**
 * 权限管理的字典列表
 * @param data
 */
export function dictGetDataType(data) {
  return request({
    url: '/base/enums/select/dictionaries/type',
    method: 'post',
    data
  })
}

/**
 * 权限管理的地区列表
 * @param data
 */
export function areaSelectList(data) {
  return request({
    url: '/area/selectList',
    method: 'post',
    data
  })
}

/**
 * 权限管理的公司授权列表
 * @param data
 */
export function userGetPermissionCompany(data) {
  return request({
    url: '/user/getPermissionCompany',
    method: 'post',
    data
  })
}

/**
 * 权限管理的公司授权
 * @param data
 */
export function userAuthorizeCompany(data) {
  return request({
    url: '/user/authorizeCompany',
    method: 'post',
    data
  })
}

/**
 * 权限管理的项目授权列表
 * @param data
 */
export function userGetPermissionProject(data) {
  return request({
    url: '/user/getPermissionProject',
    method: 'post',
    data
  })
}

/**
 * 权限管理的获取地区的列表
 * @param data
 */
export function baseProcessSelectStage(data) {
  return request({
    url: '/base/process/selectStage',
    method: 'post',
    data
  })
}

/**
 * 校验项目授权是否需要覆盖
 * @param data
 */
export function userIsCoverProject(data) {
  return request({
    url: '/user/isCoverProject',
    method: 'post',
    data
  })
}

/**
 * 项目授权
 * @param data
 */
export function userAuthorizeProject(data) {
  return request({
    url: '/user/authorizeProject',
    method: 'post',
    data
  })
}

/**
 * 查询当前登录人角色列表
 * @param data
 */
export function roleselectUser(data) {
  return request({
    url: '/role/selectUser',
    method: 'post',
    data
  })
}

/**
 * 查询当前登录人角色列表
 * @param data
 */
export function userisCanAuthorize(data) {
  return request({
    url: '/user/isCanAuthorize',
    method: 'post',
    data
  })
}

/**
 * 查询总部
 * @param data
 */
export function baseEnumsSelectAreaNo(data) {
  return request({
    url: '/base/enums/select/area/no',
    method: 'post',
    data
  })
}
